import { useState, useEffect } from "react"
import { joinUrl } from "../utils/joinUrl"
import { useMaybeFileboy, API_URL } from "@cd2/fileboy-react"

export interface IVideoData {
  id: string
  name: string
  posterFile: { id: string } | null
  generatedPosterFile: { id: string } | null
  extractionStatus: string
  extractionStartedAt: string
  statusMessage: string
  videoFiles: {
    id: string
    processingStatus: string
    type: "video" | "audio"
    width: number | null
    height: number | null
  }[]
}

// todo move this into useFileboyVideo hook
export function useVideoData(videoId: string, apiUrl?: string) {
  const fileboy = useMaybeFileboy()
  const resolvedApiUrl = apiUrl || fileboy?.apiUrl || API_URL
  const [data, setData] = useState<null | IVideoData>(null)
  type IVideoStatus =
    | "loading"
    | "errored"
    | "done"
    | "notFound"
    | "pending"
    | "processing"
    | "error"

  const [status, setStatus] = useState<IVideoStatus>("loading")

  useEffect(() => {
    const fn = async () => {
      try {
        const url = joinUrl(resolvedApiUrl, `/videos/${videoId}/data`)
        const response = await fetch(url)
        const json = await response.json()
        if (json.error) {
          throw json.error
        } else {
          const data: IVideoData = json.data
          setData(data)
          const status = getStatusForVideoData(data)
          setStatus(status)
        }

        function getStatusForVideoData(data: IVideoData): IVideoStatus {
          if (data.extractionStatus === "error") {
            return "error"
          } else if (data.extractionStatus === "pending") {
            return "pending"
          } else if (data.extractionStatus !== "done") {
            return "processing"
          } else {
            const hasAnyAudio = data.videoFiles.some(videoFile => videoFile.type === "audio")
            const atLeastOneVideo = data.videoFiles.some(
              file => file.type === "video" && file.processingStatus === "done",
            )
            const atLeastOneAudio = data.videoFiles.some(
              file => file.type === "audio" && file.processingStatus === "done",
            )
            if ((atLeastOneVideo && atLeastOneAudio) || (!hasAnyAudio && atLeastOneVideo)) {
              return "done"
            } else {
              return "processing"
            }
          }
        }
        // const videos = await skeem.fetch<IVideoData>({
        //   videos: {
        //     attributes: [
        //       "name",
        //       "status",
        //       "posterFileboyId",
        //       { name: "files", attributes: ["type", "width", "height", "status"] },
        //     ],
        //     filter: { attrEq: { id: videoId } },
        //   },
        // })
        // const video = videos[0]
        // if (video) {
        //   setData({ ...video, manifestUrl: joinUrl(apiUrl, `/api/videos/${videoId}/manifest`) })

        //   const atLeastOneVideo = video.files.some(
        //     file => file.type === "video" && file.status === "done",
        //   )
        //   const atLeastOneAudio = video.files.some(
        //     file => file.type === "audio" && file.status === "done",
        //   )
        //   if (atLeastOneVideo && atLeastOneAudio) {
        //     setStatus("done")
        //   } else {
        //     setStatus(video.status)
        //   }
        // } else {
        //   setStatus("notFound")
        // }
      } catch (e) {
        console.error(e)
        setStatus("errored")
      }
    }
    setData(null)
    setStatus("loading")
    fn()
  }, [videoId, resolvedApiUrl])

  return [data, status] as const
}
